module.exports = __webpack_public_path__ + "img/silo_img2.a77d557b.jpeg";